import { useExperimentValue } from '@seek/candidate-feature-flag';

import {
  DynamicPillsV2,
  REFINE_BAR_V2_FEATURE_FLAG,
  RefineBarV2,
  SAVED_RECENT_SEARCHES_FEATURE_FLAG,
  StickySearchBar,
  type RefineBarV2Experiment,
} from 'src/config/experiments';
import { useCandidateDetails } from 'src/modules/hooks/useCandidateDetailsQuery.ts';

import { useSelector } from '../react';

import { selectFeatureFlag } from './selectors';

export const useIsHomepageRecsBadgingStrongApplicantEnabled = () =>
  useSelector(selectFeatureFlag('homepageRecsBadgingStrongApplicant'));

export const useIsHomepageRecsBadgingExpiringSoonEarlyApplicantEnabled = () =>
  useSelector(
    selectFeatureFlag('homepageRecsBadgingExpiringSoonEarlyApplicant'),
  );

export const useIsHomepageGenAIChatEnabled = () => {
  const isHomepageGenAIChatEnabled = useSelector(
    selectFeatureFlag('homepageGenAIChat'),
  );

  const allowedList: number[] = [582665568, 30234635];
  const { id: seekerId } = useCandidateDetails();

  return (
    isHomepageGenAIChatEnabled ||
    Boolean(seekerId && allowedList.includes(seekerId))
  );
};

export const useIsHomepageGenAIChatAltModelEnabled = () =>
  useSelector(selectFeatureFlag('homepageGenAIChatAltModel'));

export const useFeatureFlagRefineBarV2Experiment = () => {
  const value = useExperimentValue<RefineBarV2Experiment>(
    REFINE_BAR_V2_FEATURE_FLAG,
  );

  return {
    dynamicPillsV2: value === DynamicPillsV2,
    stickySearchBar: value === StickySearchBar,
    refineBarV2: value === RefineBarV2,
  };
};

export const useSavedRecentSearchesFeatureFlag = () =>
  useExperimentValue(SAVED_RECENT_SEARCHES_FEATURE_FLAG);
